import { Action } from '@ngrx/store';
import { Group } from '../../shared/models/groups/groups.model';
import { ValidationResponseModel } from '../../shared/models/validation-response.model';

export const SWITCH_SEARCH_TYPE = '[XENA] SWITCH_SEARCH_TYPE';
export const OPEN_ADD_TO_LEAFLET_DIALOG = '[XENA] OPEN_ADD_TO_LEAFLET_DIALOG';
export const CLOSE_ADD_TO_LEAFLET_DIALOG = '[XENA] CLOSE_ADD_TO_LEAFLET_DIALOG';
export const SWITCH_MAP = '[XENA] SWITCH_MAP';
export const OPEN_MAP = '[XENA] OPEN_MAP';
export const CLOSE_MAP = '[XENA] CLOSE_MAP';
export const SWITCH_FULLSCREEN_MAP = '[XENA] SWITCH_FULLSCREEN_MAP';
export const OPEN_FULLSCREEN_MAP = '[XENA] OPEN_FULLSCREEN_MAP';
export const CLOSE_FULLSCREEN_MAP = '[XENA] CLOSE_FULLSCREEN_MAP';
export const SWITCH_EXTENDED_SEARCH = '[XENA] SWITCH_EXTENDED_SEARCH';
export const OPEN_EXTENDED_SEARCH = '[XENA] OPEN_EXTENDED_SEARCH';
export const CLOSE_EXTENDED_SEARCH = '[XENA] CLOSE_EXTENDED_SEARCH';


export class SwitchSearchType implements Action {
	readonly type = SWITCH_SEARCH_TYPE;

	constructor(public payload: string) {}
}

export class OpenAddToLeafletDialog implements Action {
	readonly type = OPEN_ADD_TO_LEAFLET_DIALOG;
	constructor(public payload: string) {}
}

export class CloseAddToLeafletDialog implements Action {
	readonly type = CLOSE_ADD_TO_LEAFLET_DIALOG;
}

export class SwitchMap implements Action {
	readonly type = SWITCH_MAP;
}

export class OpenMap implements Action {
	readonly type = OPEN_MAP;
}

export class CloseMap implements Action {
	readonly type = CLOSE_MAP;
}

export class SwitchFullscreenMap implements Action {
	readonly type = SWITCH_FULLSCREEN_MAP;
}

export class OpenFullScreenMap implements Action {
	readonly type = OPEN_FULLSCREEN_MAP;
}

export class CloseFullscreenMap implements Action {
	readonly type = CLOSE_FULLSCREEN_MAP;
}

export class SwitchExtendedSearch implements Action {
	readonly type = SWITCH_EXTENDED_SEARCH;
}

export class OpenExtendedSearch implements Action {
	readonly type = OPEN_EXTENDED_SEARCH;
}

export class CloseExtendedSearch implements Action {
	readonly type = CLOSE_EXTENDED_SEARCH;
}

export type All
	= SwitchSearchType
	| OpenAddToLeafletDialog
	| CloseAddToLeafletDialog
	| SwitchMap
	| OpenMap
	| CloseMap
	| SwitchFullscreenMap
	| OpenFullScreenMap
	| CloseFullscreenMap
	| SwitchExtendedSearch
	| OpenExtendedSearch
	| CloseExtendedSearch;



// WEBPACK FOOTER //
// ./src/app/xena/core/state-management/actions/settings.ts